import { FieldValidation } from '@atlassian/mpac-utils';
import { checkNonEmptyVendorPaymentField, checkOptionalVendorPaymentField } from "../PartnerPaymentInfo.utils";
const {
  checkLengthInRange,
  checkMaxLength,
  checkNonEmptyAlphanumeric,
  checkNonEmptyDigits,
  checkNonEmptyString
} = FieldValidation;
export const countriesRequiringLocalBankId = ['AU', 'CA', 'CN', 'NZ', 'RU'];
export const validateRoutingNumber = value => checkNonEmptyDigits('Routing number')(value) || checkLengthInRange('Routing number', 9, 10)(value);
export const validateAccountName = value => checkOptionalVendorPaymentField('Account holder name')(value) || checkMaxLength('Account holder name', 138)(value);
export const validateIntermediaryBankId = (value, {
  intermediaryBankName
}) => {
  if (intermediaryBankName && intermediaryBankName.length > 0) {
    return checkNonEmptyString('Intermediary bank ID')(value);
  }
};
export const validateIntermediaryBankName = (value, {
  intermediaryBankId
}) => {
  if (intermediaryBankId && intermediaryBankId.length > 0) {
    return checkNonEmptyVendorPaymentField('Intermediary bank name')(value);
  }
};
export const validateLocalBankId = (value, {
  bankCountry
}) => {
  if ((bankCountry === null || bankCountry === void 0 ? void 0 : bankCountry.abbr) === 'IN') {
    return checkNonEmptyAlphanumeric('Local bank ID')(value);
  } else if (countriesRequiringLocalBankId.includes(bankCountry === null || bankCountry === void 0 ? void 0 : bankCountry.abbr)) {
    return checkNonEmptyDigits('Local bank ID')(value);
  }
};